import {
    GET_NEWS_ITEMS,
    GET_NEWS_ITEMS_SUCCESS,
    GET_NEWS_ITEMS_ERROR,
    UPDATE_NEWS_ITEM,
    UPDATE_NEWS_ITEM_SUCCESS,
    UPDATE_NEWS_ITEM_ERROR,
    UPDATE_NEWS_FEED,
    ADD_COMMENT_SUCCESS,
    ADD_COMMENT_ITEM,
    ADD_COMMENT_ERROR,
    GET_COMMENTS,
    GET_COMMENTS_SUCCESS,
    GET_COMMENTS_ERROR,
    GET_LIKED_POSTS_BY_CURRENT_USER,
    GET_LIKED_POSTS_BY_CURRENT_USER_SUCCESS,
    GET_LIKED_POSTS_BY_CURRENT_USER_ERROR,
    GET_POST_LIKES,
    GET_POST_LIKES_SUCCESS,
    GET_POST_LIKES_ERROR,
    GET_NEWS_ITEM,
    GET_NEWS_ITEM_SUCCESS,
    GET_NEWS_ITEM_ERROR,
} from '../actions';

const INIT_STATE = {
    pageNumber: 1,
    newsItems: null,
    selectedNewsItem: null,
    updatedNewsItem: null,
    loading: false,
    isLiked: null,
    isDelete: false,
    comment: null,
    list: null,
    postId: null,
    likedPostIds: [],
    likeCountOfPosts: [],
    error: '',
    newsItem:null,
    articleId:0
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_NEWS_ITEM:
            return { ...state, loading: true, error: '', articleId: action.payload.articleId };
        case GET_NEWS_ITEM_SUCCESS:
            return { ...state, loading: false, error: '', newsItem: action.payload.newsItem };
        case GET_NEWS_ITEM_ERROR:
            return { ...state, loading: false, error: action.payload.message };        
        case GET_NEWS_ITEMS:
            return { ...state, loading: true, error: '', pageNumber: action.payload.pageNumber };
        case GET_NEWS_ITEMS_SUCCESS:
            return { ...state, loading: false, error: '', newsItems: action.payload.newsItems };
        case GET_NEWS_ITEMS_ERROR:
            return { ...state, loading: false, error: action.payload.message };
        case UPDATE_NEWS_ITEM: {
            let likedPostIds = state.likedPostIds ? [...state.likedPostIds] : [];
            const likeCountOfPosts = state.likeCountOfPosts ? [...state.likeCountOfPosts] : [];
            const postIndex = likeCountOfPosts.findIndex(p => p.postId === action.payload.newsItem.aboutRecordId);
            if (action.payload.isLiked) {
                likedPostIds = [...likedPostIds, action.payload.newsItem.aboutRecordId];
                likeCountOfPosts[postIndex > -1 ? postIndex : likeCountOfPosts.length] = { postId: action.payload.newsItem.aboutRecordId, likeCount: postIndex > -1 ? (likeCountOfPosts[postIndex].likeCount + 1) : 1 };
            } else if (action.payload.isLiked == false) {
                likedPostIds = likedPostIds.filter(pid => pid !== action.payload.newsItem.aboutRecordId);
                likeCountOfPosts[postIndex > -1 ? postIndex : likeCountOfPosts.length] = { postId: action.payload.newsItem.aboutRecordId, likeCount: postIndex > -1 ? (likeCountOfPosts[postIndex].likeCount - 1) : 1 };
            }
            return { ...state, loading: true, error: '', likedPostIds, likeCountOfPosts, isLiked: action.payload.isLiked, isDelete: action.payload.isDelete };
        }
        case UPDATE_NEWS_ITEM_SUCCESS:
            return { ...state, loading: false, error: '', updatedNewsItem: action.payload.updatedNewsItem };
        case UPDATE_NEWS_ITEM_ERROR:
            return { ...state, loading: false, error: action.payload.message };
        case ADD_COMMENT_ITEM:
            return { ...state, loading: true, error: '', comment: action.payload.comment };
        case ADD_COMMENT_SUCCESS:
            return { ...state, loading: false, error: '', updatedNewsItem: action.payload.updatedNewsItem };
        case ADD_COMMENT_ERROR:
            return { ...state, loading: false, error: action.payload.message };
        case GET_COMMENTS:
            return { ...state, loading: true, error: '', postId: action.payload.postId };
        case GET_COMMENTS_SUCCESS:
            return { ...state, loading: false, error: '', list: action.payload.list };
        case GET_COMMENTS_ERROR:
            return { ...state, loading: false, error: action.payload.message };
        case GET_LIKED_POSTS_BY_CURRENT_USER:
            return { ...state, loading: true, error: '' };
        case GET_LIKED_POSTS_BY_CURRENT_USER_SUCCESS:
            return { ...state, loading: false, error: '', likedPostIds: action.payload.likedPostIds };
        case GET_LIKED_POSTS_BY_CURRENT_USER_ERROR:
            return { ...state, loading: false, error: action.payload.message };
        case GET_POST_LIKES:
            return { ...state, loading: true, error: '' };
        case GET_POST_LIKES_SUCCESS: {
            const likesOfPosts = state.likeCountOfPosts ? [...state.likeCountOfPosts] : [];
            const postPosition = likesOfPosts.findIndex(p => p.postId === action.payload.postId);
            likesOfPosts[postPosition > -1 ? postPosition : likesOfPosts.length] = { postId: action.payload.postId, likeCount: action.payload.likeCount };
            return { ...state, loading: false, error: '', likeCountOfPosts: likesOfPosts };
        }
        case GET_POST_LIKES_ERROR:
            return { ...state, loading: false, error: action.payload.message };
        case UPDATE_NEWS_FEED:
            return { ...state, ...action.payload.updatedValues }
        default: return { ...state };
    }
}
